<!-- TODO: this might be complicated enough to be worth splitting into multiple
 components -->

@let processAssociations = processAssociationsSg();
@let process = processSg();
@let isProcessExpanded =
  processesUiPlugin.feature.selectors.isProcessExpanded({ process }).asSignal();
@let presentStopDialog =
  processesUiPlugin.feature.selectors
    .isMarkedForStop({ processId: process.id })
    .asSignal();
@let processesPolling =
  processPollingPlugin.feature.selectors.isStarted.asSignal();

<div class="atn-process">
  <div class="atn-process__info">
    <div class="atn-process__actions">
      <i
        class="atn-icon atn-triangle-{{
          isProcessExpanded ? 'down' : 'right'
        }} atn-blue"
        (click)="expandButtonClickHandler(process)"
      ></i>
    </div>
    <div class="atn-process__content">
      <div class="atn-process__header">
        <div class="atn-process__name">
          {{ process.name }}
          ({{ process.progress | atnDsFormattedValue: Intrinsic.Percent }})
        </div>

        @if (process.date) {
          <div
            class="atn-process__time"
            [title]="
              processDurationSg() ? 'Ran for ' + processDurationSg() : ''
            "
          >
            {{ processDateSg() }}
          </div>
        }
      </div>
      @if (process.status) {
        <div class="atn-process__status">
          <div
            data-test-id="processStatus"
            class="atn-process__status-fill-color"
            [style.background-color]="displayStatusSg().fillColor"
          >
            <!-- NOTE: adding -animated class only when pooling is enabled -->
            <div
              class="atn-process__status-progress"
              [class.atn-process__status-progress--animated]="
                process.status === ProcessStatus.InProgress && processesPolling
              "
              [style.background-color]="displayStatusSg().progressColor"
              [style.width]="
                process.progress | atnDsFormattedValue: Intrinsic.Percent
              "
            ></div>
          </div>
          <div class="atn-process__status-icon">
            <i
              data-test-id="processStatusMessage"
              class="atn-icon"
              [class]="displayStatusSg().iconClass"
              [atnDsTooltip]="process.detail"
              atnDsTooltipPosition="above"
            ></i>
          </div>
        </div>
      } @else {
        <div class="atn-process__status">Status unknown</div>
      }
    </div>
    <div
      class="atn-process__overflow"
      #optionOverlayTrigger
    >
      <i
        class="atn-icon atn-overflow atn-blue"
        (click)="isOptionsOverlayOpened = true"
      ></i>
    </div>
  </div>
  @if (isProcessExpanded) {
    <div class="atn-process__steps">
      @for (step of process.steps; track $index) {
        <div class="atn-process__step">
          <i
            class="atn-icon"
            [class]="getEffectiveStepIconClass(step)"
            [atnDsTooltip]="getEffectiveStepTooltip(step)"
            atnDsTooltipPosition="above"
          ></i>
          {{ step.name }}
        </div>
      }
    </div>
  }
  <div class="atn-process__associations">
    <span class="atn-process__associations-text">{{
      processAssociations
    }}</span>
  </div>

  @if (isOptionsOverlayOpened) {
    <atn-ds-attached-overlay
      [origin]="optionOverlayTrigger"
      [offsetX]="-10"
      [offsetY]="-5"
      backdropClass="ds-global-overlay-backdrop"
      [hasBackdrop]="true"
      (backdropClick)="isOptionsOverlayOpened = false"
    >
      <div class="atn-process__options">
        @if (process.status === ProcessStatus.InProgress) {
          <div
            class="atn-process__options-item"
            (click)="
              isOptionsOverlayOpened = false;
              onProcessStopOptionClickedHandler()
            "
          >
            Stop
          </div>
        }
        <div
          class="atn-process__options-item"
          (click)="
            isOptionsOverlayOpened = false;
            onProcessDeleteOptionClickedHandler()
          "
        >
          Delete
        </div>
      </div>
    </atn-ds-attached-overlay>
  }

  @if (presentStopDialog) {
    <atn-ds-confirmation-overlay
      [title]="'Do you want to stop process: ' + process.name + ' ?'"
      [description]="
        'Stopping your process: ' +
        process.name +
        ' will terminate it immediately. Any partially imported data will remain. This can\'t be undone.'
      "
      (cancel)="onStopCancelledHandler()"
      (confirm)="onStopConfirmedHandler()"
      confirmButtonText="STOP"
    >
    </atn-ds-confirmation-overlay>
  }

  @if (presentProcessDeletionDialogSg()) {
    <atn-ds-confirmation-overlay
      [title]="'Do you want to delete process: ' + process.name + ' ?'"
      [description]="
        'Deleting your process: ' +
        process.name +
        ' can\'t be undone. Are you sure you want to delete your ' +
        process.name +
        ' ?'
      "
      (cancel)="onDeleteDialogNoBtnClickedHandler()"
      (confirm)="onDeleteDialogYesBtnClickedHandler()"
      confirmButtonText="DELETE"
    >
    </atn-ds-confirmation-overlay>
  }
</div>
